import { render, staticRenderFns } from "./appendix_blog.vue?vue&type=template&id=747047c2&scoped=true&"
import script from "./appendix_blog.vue?vue&type=script&lang=js&"
export * from "./appendix_blog.vue?vue&type=script&lang=js&"
import style0 from "./appendix_blog.vue?vue&type=style&index=0&id=747047c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747047c2",
  null
  
)

export default component.exports